import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const elem = <App />;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(elem);
